export default __webpack_public_path__ + "static/media/vsq-logo-vectorBASEWhiteLogo@2x.c6cf3f09.png";